const mobileMenuToggle = document.querySelector("#toggleMenu");

if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("click", function () {
        const body = document.querySelector('body')
        body.classList.toggle("mobile-menu-is-open")
    });
}